import React from 'react';
import {useSvgToElements} from './useSvgToElements';

export const NewTabSmallThin = (
  props: any
): React.ReactElement<React.ComponentProps<'svg'>> => {
  const svgProps = useSvgToElements({
    ...props,
    width: 11,
    height: 11,
    name: 'new-tab-small-thin',
  });

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" {...svgProps}>
      <path
        fill="currentColor"
        d="M5 1v1h3.293L4.646 5.646l.707.707L9 2.707V6h1V1H5zm2 8H2V4h2V3H2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V7H7v2z"
      />
    </svg>
  );
};

export default NewTabSmallThin;
